'use client'

import React from 'react'
import { useLocale, useTranslations } from 'next-intl'
import { Container } from '@/components/design-system/Container'
import { Typography } from '@/components/design-system/Typography'
import { notFound, usePathname } from 'next/navigation'
import { getRouteFromUrl } from '@/lib/navigation'
import { Locale } from '@/constants/locales'
import SchemaScript from '@/components/common/SchemaScript'

interface AgreementPageProps {
    children: React.ReactNode
}

const AgreementPage: React.FC<AgreementPageProps> = ({
    children
}) => {
    const t = useTranslations()
    const pathname = usePathname();
    const locale = useLocale();
    const routeEntry = getRouteFromUrl(pathname, locale as Locale);

    if (!routeEntry) {
        return notFound();
    }

    const title = routeEntry?.route?.id === 'privacy-policy' ? t('privacyPolicy.title') : t('termsOfUse.title');
    const lastUpdated = routeEntry?.route?.id === 'privacy-policy' ?
        t('privacyPolicy.lastUpdated', { DATE: new Date('2025-08-03').toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' }) })
        : t('termsOfUse.lastUpdated', { DATE: new Date('2025-08-03').toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' }) });

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 py-12">
                <Container>
                    {/* Document Header */}
                    <div className="text-center mb-8">
                        <Typography variant="h1" className="mb-2 text-gray-900">
                            {title}
                        </Typography>
                        <Typography variant="small" className="text-gray-600 text-center mt-10">
                            {lastUpdated}
                        </Typography>
                    </div>

                    {children}
                </Container>
            </div>

            {routeEntry?.route?.schema && (
                <SchemaScript route={routeEntry.route} locale={locale as Locale} />
            )}
        </>
    )
}

export default AgreementPage
